var Teachers = {
    bindAdditionalPupilSearch: function() {
        $('.additional-pupil-search').select2({
          ajax: {
            url: '/admin/pupils/ajax?includeClass=1',
            placeholder: 'Enter name here...',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                page: params.page
              };
            },
            results: function (data, page) {
                return { results: data.results };
            },
          },
          minimumInputLength: 3
        });

        // var selectedItems = $('.additional_pupil_ids');
        // selectedItems.each(function(i, el) {
        //     var input = $(el);
        //     var $option = $('<option selected="selected">' + input.data('name') + '</option>').val(input.val());
        //     console.log(input.data('name'));
        //     $('#additional_pupils').append($option).trigger('change');
        // });
    },

    bindSearchSelect: function() {
        $('.teacher-search').select2({
          ajax: {
            url: '/admin/users/ajax',
            placeholder: 'Enter name here...',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                page: params.page
              };
            },
            results: function (data, page) {
                return { results: data.results };
            },
          },
          minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/admin/users/' + $(this).select2('data')[0].id + '/edit/';
        });
    }
};
